import React, { useState } from "react";
import popup from "./cliffing.jpg";

const BlurMessageOverlay = ({
  message = "Your message here",
  isVisible = true,
  children,
}) => {
  const [visible, setVisible] = useState(isVisible);

  const goBack = () => {
    window.history.back();
  };

  const overlayStyles = {
    container: {
      position: "relative",
      width: "100%",
      height: "100%",
    },
    blurredContent: {
      filter: "blur(5px)",
      pointerEvents: "none",
      transition: "all 0.3s ease",
    },
    normalContent: {
      transition: "all 0.3s ease",
    },
    messageOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 999,
    },
    messageBox: {
      backgroundColor: "white",
      padding: "24px",
      borderRadius: "8px",
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
      maxWidth: "40%",
      margin: "0 auto",
      textAlign: "center",
      position: "relative",
    },
    messageTitle: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "12px",
      color: "#6600CC",
    },
    messageContent: {
      fontSize: "14px",
      color: "#444",
      lineHeight: 1.5,
    },
    button: {
      marginTop: "16px",
      backgroundColor: "#6600CC",
      color: "white",
      border: "none",
      borderRadius: "6px",
      padding: "8px 16px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "500",
    },
    backButton: {
      position: "absolute",
      top: "10px",
      left: "10px",
      backgroundColor: "#6600CC",
      color: "white",
      border: "none",
      borderRadius: "4px",
      padding: "5px 10px",
      cursor: "pointer",
      fontSize: "12px",
      fontWeight: "500",
      zIndex: 1000,
    },
  };

  return (
    <div style={overlayStyles.container}>
      <div
        style={
          visible ? overlayStyles.blurredContent : overlayStyles.normalContent
        }
      >
        {children}
      </div>

      {visible && (
        <div style={overlayStyles.messageOverlay}>
          <div style={overlayStyles.messageBox}>
            <button style={overlayStyles.backButton} onClick={goBack}>
              Back
            </button>
            <img src={popup} className="img-fluid" alt="Popup" />
          </div>
        </div>
      )}
    </div>
  );
};

export default BlurMessageOverlay;
